import React from 'react';
import {FormGroup, Label, Input } from 'reactstrap'

const FL141 = props => {
    return (
        <div>
            {/* Q1 */}
          <FormGroup>
          <Label for="receiveSpousal">I am <strong>Attorny</strong> For </Label>
        <Input type="select" name="receiveSpousal" id="receiveSpousal">
        <option disabled selected value> -- select an option -- </option>
          <option>Petitioner </option>
          <option>Respondent</option>
        </Input>
          </FormGroup>
        </div>
    );
};


export default FL141;